
import Traderlist from '@/components/service/newjoin/Traderlist.vue'
import Counttitle from '@/components/service/newjoin/Counttitle.vue'
import Button from '@/components/detail/Button.vue'
export default {
  components: { Traderlist, Counttitle, Button },
  props: {
    type: {
      // 企业类型-服务商1，交易商2
      type: Number,
      default: 2
    },
    addtradertype: {
      // 0加入还是1认领
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      traderword: '',
      listdata: [],
      searchshow: false,
      loadshow: false
    }
  },
  computed: {
    ptext() {
      // 根据交易商还是服务商显示文本
      if (this.type == 2) {
        // 交易商
        return {
          p1: this.$v('请输入交易商名称'),
          p2: this.$v('您可以通过以下两种方式成为交易商身份'),
          p3: this.$v('认领交易商'),
          p4: this.$v('认领验证成功后即可成为该交易商的管理员'),
          p5: this.$v('我是企业员工'),
          p6: this.$v('验证通过后，即可发表带有企业标识的内容'),
          p7: this.$v('选择交易商')
        }
      } else {
        // 服务商
        return {
          p1: this.$v('请输入服务商名称'),
          p2: this.$v('验证成功后即可成为该服务商的员工'),
          p3: this.$v('我是企业员工'),
          p4: this.$v('验证成功后即可成为该服务商的员工'),
          p5: this.$v('创建服务商'),
          p6: this.$v('{0}，创建属于自己的全新服务商组织，创建后即为服务商管理员').replace('{0}', `<span>${this.$v('WikiFX未收录')}</span>`),
          p7: this.$v('选择服务商')
        }
      }
    }
  },
  // watch: {
  //   traderword () {
  //     console.log(123)
  //     if (!this.traderword) {
  //       this.listdata = []
  //       return
  //     }
  //     this.searchfn()
  //   }
  // },
  mounted() {
    this.$emit('searchshowfn', false)
  },
  methods: {
    btfn() {
      // 点击登录按钮
      if (!this.traderword) return
      this.$emit('searchshowfn', true)
      this.searchfn()
    },
    searchfn() {
      let project = 1
      let objtype = 1
      if (this.type == 1) {
        // 服务商
        project = 3
        objtype = 3
      } else {
        // 交易商
        project = 1
        objtype = 1
      }
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            content: this.traderword,
            pageSize: 30,
            pageIndex: 1,
            isApp: false,
            project,
            type: objtype,
            product: 2
          },
          {
            Routes: 'weenterprisemanage$search'
          }
        )
        .then((res) => {
          console.log(res, 333)
          const search = (res && res.weenterprisemanage && res.weenterprisemanage.search && res.weenterprisemanage.search.data && res.weenterprisemanage.search.data.items) || []
          search.forEach((item) => {
            item.labelsarr = []
            item.labels &&
              item.labels.forEach((val) => {
                val.Data.forEach((m) => {
                  item.labelsarr.push(m.labelName)
                })
              })
          })
          this.listdata = [...search]
          this.$nextTick(() => {
            this.searchshow = true
            this.loadshow = true
          })
        })
    },
    myAdd(val) {
      // 加入按钮
      this.$emit('myAdd', val)
    },
    myclaim(val) {
      // 认领按钮
      this.$emit('myclaim', val)
    },
    closefn() {
      this.searchshow = false
      this.$emit('searchshowfn', false)
    },
    createserve() {
      this.$emit('createserve')
    }
  }
}
